import {observable, action, computed} from 'mobx';
import _ from 'lodash';
import SectionViewModel from './SectionViewModel';
import SuggestionViewModel from './SuggestionViewModel';

class GlobalSearchState {
  store;
  @observable query;
  @observable suggestions = null;

  constructor(store) {
    this.store = store;
  }

  @action updateQuery(query) {
    this.query = query;

    if (!query.length) {
      this.suggestions = null;
      return;
    }

    this.store.fetchSuggestions(query, suggestions => this.onSuggestionsReceived(suggestions));
  }

  @action onSuggestionsReceived(suggestions) {
    const viewModels = _.map(
      suggestions,
      s => new SuggestionViewModel(s)
    );
    this.suggestions = viewModels;
  }

  @computed get sections() {
    if (this.suggestions === null) return null;

    const suggestionsByType = _.groupBy(
      this.suggestions,
      s => s.data.suggestionType
    );

    return _.chain(suggestionsByType)
      .map(items => new SectionViewModel(items, this.query))
      .orderBy(v => v.priority * -1)
      .value();
  }

  @computed get sortedSuggestions() {
    return _.chain(this.sections)
      .map(section => section.suggestionViewModels.slice())
      .flatten()
      .value();
  }
}

export default GlobalSearchState;
